import React, { useEffect, useState, useContext } from "react";
import { ThemeContext } from "styled-components";
import { useHistory, withRouter } from "common/src/router/compat";
import { useLocation } from "common/src/router/compat";
import { useScrollPosition } from "common/src/helpers/useScrollPosition";
import { useTranslation } from "react-i18next";
import { ReactComponent as MainLogoABC } from "../../../abc/src/data/icon-component/abc-logo.svg";
import { ReactComponent as LogoMobileABC } from "../../../abc/src/data/icon-component/abc-logo-mobile.svg";
import { ReactComponent as MainLogoPUB } from "../../../pub/src/data/icon-component/logo.svg";
import { ReactComponent as LogoMobilePUB } from "../../../pub/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoYET } from "../../../yet/src/data/icon-component/logo.svg";
import { ReactComponent as MobileLogoYET } from "../../../yet/src/data/icon-component/logo-mobile.svg";
import { ReactComponent as MainLogoFUN } from "../../../fun/src/data/icon-component/logo.svg";
import { ReactComponent as MobileLogoFUN } from "../../../fun/src/data/icon-component/logo-mobile.svg";
import { ReactComponent as MainLogoCAC } from "../../../cac/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoHYC } from "../../../hyc/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoQBC } from "../../../qbc/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoBEC } from "../../../bec/src/data/icon-component/logo.svg";

import { isMobile } from "react-device-detect";
import { handleOrientationChange } from "common/src/helpers/isPortrait";
import { LogoWrapper } from "../styledComponents/CommonStyledComponents";
import Cookies from "js-cookie";

const Logo = ({ isSWEIp, classOnScroll, setOpen, defaultLang, player }) => {
  const { i18n } = useTranslation("");
  const svgOnScroll = classOnScroll ? "" : "svgchanger";
  const [hideOnScroll, setHideOnScroll] = useState(true);
  const [isOnLending, setIsOnLending] = useState(false);
  const themeContext = useContext(ThemeContext);
  /* const [isPortrait, setIsPortrait] = useState(false); */
  const baseUrl = `/${
    i18n.language || window.localStorage.i18nextLng || defaultLang
  }`;
  const indexPage =
    useLocation().pathname.split("/")[2] === "index" ? true : false;
  const history = useHistory();
  const topMarginForSWE = isSWEIp && hideOnScroll ? "margin-top" : "";

  // index.js
  window.onscroll = function () {
    themeContext.skin === "abc" && scrollRotate();
  };

  const scrollRotate = () => {
    let logo = document.querySelector(".spin");
    if (logo !== null)
      logo.style.transform = `rotate(${window.pageYOffset * 0.1}deg)`;
  };

  const scrollToTop = () => {
    setOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useScrollPosition(
    ({ currPos }) => {
      const isShow = Math.abs(currPos.y) < 150;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  useEffect(() => {
    if (Cookies.get("land") && themeContext.skin === "yet") {
      setIsOnLending(true);
    } else {
      setIsOnLending(false);
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      window.addEventListener("orientationchange", handleOrientationChange);
      return () =>
        window.removeEventListener(
          "orientationchange",
          handleOrientationChange
        );
    }
  }, [handleOrientationChange]);

  let logoClass = isMobile
    ? location.pathname === baseUrl + "/index"
      ? handleOrientationChange()
        ? "logo "
        : "logo-landscape "
      : handleOrientationChange()
        ? "logo-not-landing "
        : "logo-landscape "
    : location.pathname !== baseUrl + "/index"
      ? isOnLending
        ? "logo-not-landing-yet "
        : "logo-not-landing "
      : "logo ";

  const skinLogo = () => {
    let LogoComponent;
    let logoStyle;

    //ABC LOGO
    if (themeContext.skin === "abc") {
      LogoComponent = isMobile ? LogoMobileABC : MainLogoABC;
    }
    // PUB LOGO
    if (themeContext.skin === "pub") {
      LogoComponent = isMobile ? LogoMobilePUB : MainLogoPUB;
      /* LogoComponent = isMobile ? LogoMobilePUB : MainLogoPUB; */
    }
    //YET LOGO
    if (themeContext.skin === "yet") {
      LogoComponent = isMobile ? MobileLogoYET : MainLogoYET;
    }
    //FUN LOGO
    if (themeContext.skin === "fun") {
      LogoComponent = isMobile ? MobileLogoFUN : MainLogoFUN;
    }
    //CAC LOGO
    if (themeContext.skin === "cac") {
      LogoComponent = /* isMobile ? MobileLogoFUN : */ MainLogoCAC;
    }
    //HYC LOGO
    if (themeContext.skin === "hyc") {
      LogoComponent = /* isMobile ? MobileLogoFUN : */ MainLogoHYC;
    }
    //QBC LOGO
    if (themeContext.skin === "qbc") {
      LogoComponent = /* isMobile ? MobileLogoFUN : */ MainLogoQBC;
    }
    //BEC LOGO
    if (themeContext.skin === "bec") {
      LogoComponent = /* isMobile ? MobileLogoFUN : */ MainLogoBEC;
    }

    //custom css setter
    if (isMobile) {
      if (!svgOnScroll) {
        logoStyle = logoClass + topMarginForSWE + svgOnScroll + " spin";
      } else {
        logoStyle = "logo-mobile " + svgOnScroll + " spin";
      }
    } else {
      logoStyle = logoClass + topMarginForSWE + svgOnScroll + " spin";
    }

    return (
      <LogoWrapper
        // player={!player}
        onClick={() =>
          indexPage
            ? scrollToTop()
            : window.location.pathname !== baseUrl + "/maintenance"
              ? history.push(baseUrl + "/index")
              : null
        }
      >
        <LogoComponent className={logoStyle} />
      </LogoWrapper>
    );
  };

  return skinLogo();
};

export default withRouter(Logo);
